import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PayNowButton from "./components/PayNow";
import Paywall from "./components/Paywall";
import Pending from "./components/Pending";
import BBBHtmlPage from "./pages/bbb";
// import HomePage from "./components/HomePage"; // Assume you have a HomePage component

function App() {
  const authToken = localStorage.getItem("bearerToken");

  return (
    <Router>
      <div className="App App-body">
        <Routes>
          {console.log(authToken)}
          <Route path="/pending" element={<Pending authToken={authToken} />} />
          <Route path="/bbb" element={<BBBHtmlPage />} />

          <Route
            path="/"
            element={
              <Paywall
                imageUrl="https://media.stage.in/subscription/tnpl_2/har_hin_offer_explainer_image_7_199_p16.jpg"
                videoUrl="https://media.stage.in/subscription/tnpl_2/NC_paywall_trial_har_hindi_v1.mp4"
                buttonText="Click Me"
                onButtonClick={() => console.log("Button clicked")}
              />
            }
          />
          {/* <Route path="/pay" element={<PayNowButton />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
